import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import { createPinia } from "pinia";
import i18n from "./i18n";

//import excel from "vue-excel-export";
import VueSocialSharing from "vue-social-sharing";
import VueTheMask from "vue-the-mask";
import Vue3Marquee from "vue3-marquee";
import Popper from "vue3-popper";

const app = createApp(App);

app.config.globalProperties.$filters = {
  timeAgo(date) {
    return moment(date).fromNow();
  },
};

//const app = createApp(App);
app.component("Popper", Popper);

app.use(createPinia());
//app.use(excel);
app.use(VueSocialSharing);
app.use(VueTheMask);
app.use(Vue3Marquee);
app.use(i18n);
app.use(store).use(router).mount("#app");
